import { createUserAssessment, updateGUAs } from './'
import { db } from '../../../config/firebaseconfig';

/**
 * Processes all of the student data and creates the userAssessments.
 * @param {array} records the uploaded, parsed data to be processed
 * @param {object} school The school object
 * @param {string} schoolYear The active school year ('2018' for 2018-19, for example)
 * @param {string} assessmentId The id of the assessment we are uploading data about
 * @param {function} updateState this.setState bound to UploadCSVContainer
 * @returns {array} objects of the created userAssessments
 */
export default function createUserAssessments (records, school, schoolYear, assessmentId, updateState) {
  // get all sets and items (needed for initializeNewUserAssessment)
  const fetchSets = db.collection('sets').get()
  const fetchItems = db.collection('contentItems').get()
  return Promise.all([fetchSets, fetchItems, ])
    .then(results => {
      // parse the db records into sets and items objects
      const [setsResults, itemsResults ] = results
      let sets = {}, items = {}
      setsResults.forEach(doc => {
        if (doc.exists) {
          const set = doc.data()
          if (!set.deleted) sets[doc.id] = set
        }
      })
      itemsResults.forEach(doc => {
        if (doc.exists) {
          const item = doc.data()
          if (!item.deleted) items[doc.id] = item
        }
      })
      let promises = []
      // call createUserAssessment for each set of
      // student data being uploaded
      records.forEach(record => {
        const p = createUserAssessment(
          record, 
          school, 
          schoolYear, 
          assessmentId, 
          sets, 
          items, 
          updateState
        )
        promises.push(p)
      })
      updateState({totalStudents: promises.length})
      return Promise.all(promises)
    })
    .then(results => {
      let createdUserAssessments = []
      let createdUserAssessmentIds = []
      results.forEach(result => {
        if (result) {
          createdUserAssessments.push(result)
          createdUserAssessmentIds.push(result.userAssessmentId)
        }
      })
      // send request to update all affected GUAs, not mission critical
      updateGUAs(createdUserAssessments, school, schoolYear, assessmentId)

      // return the objects of the created userAssessments
      return createdUserAssessments.filter(uA => uA)
    })  
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/uploadCSV/createUserAssessments.js